var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00004 5H21C21.5523 5 22 5.44772 22 6V17H22.7959C23.4646 17 23.99 17.5343 23.99 18.203C23.99 18.3727 23.9711 18.5483 23.902 18.7034L23.8151 18.8986C23.668 19.2291 23.5678 19.3929 23.4131 19.5532C23.2624 19.7094 23.0846 19.8249 22.8806 19.899C22.6713 19.9751 22.4808 20 22.1191 20H1.88244C1.52363 20 1.33092 19.9743 1.12071 19.8971C0.915416 19.8217 0.73675 19.7044 0.585974 19.5459C0.431581 19.3837 0.331453 19.2171 0.18888 18.8878L0.106988 18.6987C-0.159784 18.0826 0.123405 17.3669 0.739509 17.1001C0.891988 17.0341 1.05638 17 1.22254 17H2.00004V6C2.00004 5.44772 2.44776 5 3.00004 5ZM3.00004 17H21V6H3.00004V17ZM1.22254 18C1.19307 18 1.16391 18.006 1.13686 18.0178C1.02757 18.0651 0.977333 18.192 1.02466 18.3013L1.10655 18.4905C1.20633 18.7209 1.24925 18.7923 1.31035 18.8565C1.35539 18.9039 1.40419 18.9359 1.46553 18.9584C1.54871 18.989 1.63131 19 1.88244 19H22.1191C22.3743 19 22.4561 18.9893 22.539 18.9591C22.5999 18.937 22.6485 18.9055 22.6935 18.8589C22.7548 18.7953 22.7978 18.725 22.9016 18.4918L22.9885 18.2966C23.0005 18.2696 23.0067 18.2404 23.0067 18.2109C23.0067 18.0944 22.9123 18 22.7958 18H1.22254Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceManagement);
export default __webpack_public_path__ + "static/media/DeviceManagement.1fe07f4f187fcd180940aa0c3c049eee.svg";
export { ForwardRef as ReactComponent };